import React from "react";
import Modal, { ModalButton } from "common/modal";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface CancelTrialPackageModalProps {
  loading: boolean;
  visible: boolean;
  isTrialPackageModal?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ModalText = styled.div`
  margin: 8px 0px 12px;
  font-size: 18px;
  color: #282828;
`;

const CancelTrialPackageModal = ({
  loading,
  visible,
  isTrialPackageModal,
  onConfirm,
  onCancel,
}: CancelTrialPackageModalProps) => {
  const { t } = useTranslation("my_credits");

  return (
    <Modal
      title={
        isTrialPackageModal ? t("CANCEL PACKAGE") : t("CANCEL SUBSCRIPTION")
      }
      visible={visible}
      onCancel={onCancel}
    >
      <ModalText>
        {t(
          "We would love to keep you with us. What about trying a smaller package? Or is there something we can do for you?"
        )}
        <br />
        <br />
        {t("Just email us at")}{" "}
        <a href="mailto:support@flexiclasses.com?subject=Cancelling&body=">
          support@flexiclasses.com
        </a>
      </ModalText>

      <br />

      <ModalButton onClick={() => onCancel()}>
        {t("I WANT TO STAY")}
      </ModalButton>
      {!isTrialPackageModal && (
        <ModalButton onClick={() => onCancel()}>
          {t("CHANGE PACKAGE")}
        </ModalButton>
      )}
      <ModalButton loading={loading} onClick={() => onConfirm()}>
        {t("CANCEL IT")}
      </ModalButton>
    </Modal>
  );
};

export default CancelTrialPackageModal;
